/* placeholder until smquestions integration */

import PropTypes from 'prop-types';
import React from 'react';
import { Checkbox, Radio } from '@sm/wds-react';
import './qz-question.scss';

const getQuestionOptions = (options, questionType) => {
  let QTypeComponent = Checkbox;
  if (questionType === 'SingleChoiceQuestion') {
    QTypeComponent = Radio;
  }
  return (
    <div>
      {options.map(option => (
        <div className="sm-qz-question--option" key={option.id}>
          <QTypeComponent label={option.text} checked={option.responded} disabled id={option.id} />
        </div>
      ))}
    </div>
  );
};

const QuizResultQuestion = ({ question }) => {
  return (
    <div className="sm-qz-question--block">
      <div className="sm-qz-question--title">
        {question.absolutePosition}. {(question.headers && question.headers[0] && question.headers[0].heading) || ''}
      </div>
      <div className="sm-qz-question--options">
        {getQuestionOptions((question.options && question.options.items) || [], question.__typename)}
      </div>
    </div>
  );
};

QuizResultQuestion.propTypes = {
  question: PropTypes.shape({
    __typename: PropTypes.string,
    position: PropTypes.number,
    absolutePosition: PropTypes.number,
    options: PropTypes.shape({
      items: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    headers: PropTypes.arrayOf(
      PropTypes.shape({
        heading: PropTypes.string,
      })
    ),
  }).isRequired,
};

export default QuizResultQuestion;
